import { gql } from "@apollo/client";

export const CREATE_GHOST_VEHICLES = gql`
  mutation createGhostVehicles($data: CreateGhostVehicleInput) {
    createGhostVehicles(data: $data) {
      success
    }
  }
`;
